module.exports = __webpack_public_path__ + "img/uy.9e4b5fb8.svg";